import L from './leaflet.js'
// Adds map.pm (drawing and editing shapes), after leaflet.js so it extends the patched Leaflet
import '@geoman-io/leaflet-geoman-free'

// The geoman setup of the maps that draw delivery zones (AreaMap, DeliveryZonesMap). Their own toolbar buttons
// (ZoneDrawingControls) switch the tools on, geoman's toolbar isn't used.

/**
 * Thin dark lines while drawing, a zone can't cross itself, Escape stops the tool that is on and the hints next to
 * the mouse while drawing ('Klik om het eerste punt te plaatsen') are in Dutch.
 */
export function setupDrawing(map: L.Map) {
    map.pm.setGlobalOptions({
        hintlineStyle: {color: '#242424', weight: 1, dashArray: [5, 5]},
        templineStyle: {color: '#242424', weight: 1},
        allowSelfIntersection: false,
        exitModeOnEscape: true
    })

    map.pm.setLang('nl')
}

/** The GeoJSON of a drawn shape as a zone stores it: a circle becomes a polygon of 60 sides */
export function toZoneGeoJSON(shape: string, layer: L.Layer) {
    return shape === 'Circle' ?
        L.PM.Utils.circleToPolygon(layer as L.Circle, 60).toGeoJSON() :
        (layer as L.Polygon).toGeoJSON()
}

/** The style a zone is drawn in */
export function zoneStyle(color?: string): L.PathOptions {
    return {color, weight: 1, fillOpacity: 0.2, opacity: 1}
}
